// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"85d70b5d","455":"35e5b79b"}[chunkId] + ".chunk.js";
};